import * as React from 'react';

import Keyboard from './Keyboard';

import * as KeyUtils from '@packages/utilities/key-utils';

type Props = {
  onEscape: (arg1: KeyboardEvent) => boolean | void;
  preventDefault?: boolean;
  children: React.ReactElement<any>;
};

export default class Escapable extends React.PureComponent<Props> {
  onEvent = (e: KeyboardEvent) => {
    if (e.keyCode === KeyUtils.ESC) {
      this.props.onEscape(e);
      if (this.props.preventDefault ?? true) {
        return false;
      }
    }
  };

  render() {
    return <Keyboard onEvent={this.onEvent}>{this.props.children}</Keyboard>;
  }
}
